import { IconName } from '@lawpilots/design-system'

import { LearnerCourseDto } from '@/services/api/tenant/learnerCourses'

type CourseActionSpec = {
  labelKey: string
  variant: 'primary' | 'secondary'
  icon?: IconName
  disabled: boolean
}

const VIEW: Omit<CourseActionSpec, 'disabled'> = { labelKey: 'my_courses_action_view', variant: 'secondary' }

/**
 * The card's single action button. Starting and continuing are the primary call to action and
 * carry the arrow that says the button leads into the course; viewing a finished one is a
 * secondary replay, so it goes bare.
 *
 * An inactive course offers the view action whatever its progress, disabled - the card cannot
 * launch what the learner is no longer entitled to, and offering "Start" for it would be a lie.
 */
export const courseAction = (course: LearnerCourseDto): CourseActionSpec => {
  if (course.availability === 'unavailable') {
    return { ...VIEW, disabled: true }
  }

  switch (course.progress) {
    case 'not_started':
      return { labelKey: 'my_courses_action_start', variant: 'primary', icon: 'arrow-right', disabled: false }
    case 'in_progress':
      return { labelKey: 'my_courses_action_continue', variant: 'primary', icon: 'arrow-right', disabled: false }
    case 'completed':
      // Nothing to replay without the stored link the view action follows.
      return { ...VIEW, disabled: !course.courseplay_url }
  }
}
